import React from 'react';
import { useAppDispatch } from '../../../store/store';
import { SetSelectedCampaign } from '../../../store/slice/campaign.slice';

interface IProps {
    setIsSwitching: React.Dispatch<React.SetStateAction<boolean>>;
}

const SwitchNewCampaign = ({ setIsSwitching }: IProps) => {
    const dispatch = useAppDispatch();

    const handlePlanSelect = () => {
        dispatch(SetSelectedCampaign(null));
        setIsSwitching(false);
    };

    return (
        <div
            className="tw-w-[328px] tw-flex tw-flex-col tw-gap-y-2 tw-items-center tw-justify-center tw-border tw-rounded-lg tw-cursor-pointer"
            onClick={handlePlanSelect}
        >
            <i className="ph-bold ph-plus lg tw-rounded-full tw-bg-purple-50 tw-text-purple-500 tw-p-3"></i>
            <div className="tw-flex tw-flex-col tw-items-center">
                <div className="tw-text-lg tw-text-[#374151]">Create New Plan</div>
                <div className="tw-text-sm tw-text-[#6B7280] ">Start from scratch</div>
            </div>
        </div>
    );
};

export default SwitchNewCampaign;
